import { useState } from 'react'
import SalesforceIcon from '../../../../../assets/source/Salesforce.svg'
import LinkedIn from '../../../../../assets/source/LinkedIn.svg'
import GoogleSheets from '../../../../../assets/source/GoogleSheets.svg'
import GoogleAnalytics from '../../../../../assets/source/GoogleAnalytics.svg'
import JiraIcon from '../../../../../assets/source/Jira.svg'
import HubspotIcon from '../../../../../assets/source/Hubspot.svg'
import AirtableIcon from '../../../../../assets/source/Airtable.svg'
import AWS from '../../../../../assets/source/AWS.svg'
import GoogleAds from '../../../../../assets/source/google-ads.svg'
import Amplitude from '../../../../../assets/source/amplitude.svg'
import { ScoopButton, ScoopText, ScoopColumn, ScoopRow } from '../../../../ui'
import styles from './SelectSource.module.scss'

export const SelectSource = ({ selectSource, source, goNext }) => {
    const sources = [
        { name: 'Salesforce', icon: SalesforceIcon },
        { name: 'LinkedIn', icon: LinkedIn },
        { name: 'Google Sheets', icon: GoogleSheets },
        { name: 'Google Analytics', icon: GoogleAnalytics },
        { name: 'Google Ads', icon: GoogleAds },
        { name: 'Amplitude', icon: Amplitude },
        { name: 'Jira', icon: JiraIcon },
        { name: 'Hubspot', icon: HubspotIcon },
        { name: 'Airtable', icon: AirtableIcon },
        { name: 'AWS', icon: AWS },
    ]

    const sourceSteps = [
        'Connect to salesforce and select the report.',
        'Prepare your data for Scoop.',
        'Scoop your data into a new dataset',
        'Match Fields from your source report to your dataset fields',
        'Complete the setup and start using your new dataset',
    ]

    const [step, setStep] = useState(0)

    const renderSourceSelection = () => {
        return (
            <ScoopColumn className={styles.container}>
                <ScoopText className={styles.title}>
                    Start by selecting your source report application
                </ScoopText>
                <div className={styles.sourcesGrid}>
                    {sources.map((source, index) => (
                        <div
                            key={index}
                            className={styles.sourceBox}
                            onClick={() => {
                                setStep(1)
                                selectSource(source)
                            }}
                        >
                            <img
                                src={source.icon}
                                alt={source.name}
                                className={styles.sourceIcon}
                            />
                            <ScoopText className={styles.sourceName}>{source.name}</ScoopText>
                        </div>
                    ))}
                </div>
            </ScoopColumn>
        )
    }

    const renderStepsToComplete = () => {
        return (
            <ScoopColumn className={styles.stepsContainer}>
                <ScoopText className={styles.title}>
                    To make the most out of this recipe, you'll need to prepare your data in{' '}
                    {source.name}.
                    <br />
                    Follow this step by step guide on how to prep your data for this recipe.
                </ScoopText>
                <div className={styles.stepsContent}>
                    <div className={styles.stepsList}>
                        {sourceSteps.map((step, index) => (
                            <ScoopRow key={index} className={styles.stepItem}>
                                <div className={styles.stepNumber}>
                                    <ScoopText>{index}</ScoopText>
                                </div>
                                <ScoopText className={styles.stepText}>{step}</ScoopText>
                            </ScoopRow>
                        ))}
                    </div>
                    <ScoopRow className={styles.buttonContainer}>
                        <ScoopButton onClick={() => {}} variant="secondary" size="small">
                            Open {source.name}
                        </ScoopButton>
                        <ScoopButton onClick={goNext} variant="primary" size="small">
                            I've done this
                        </ScoopButton>
                    </ScoopRow>
                </div>
            </ScoopColumn>
        )
    }

    return <div>{step === 0 ? renderSourceSelection() : renderStepsToComplete()}</div>
}
